// Copyright (c) 2020-2021 Visual Intelligence LP. All rights reserved.
//
import * as React from 'react';
import { withStyles } from "tss-react/mui";
import { observer } from 'mobx-react';
import { Field } from 'mobx-react-form';
import * as moment from 'moment';
// import cx from 'classnames';

// import { getTestAttr } from '@shared/utils/common';
// import { getScrollAttr } from '@shared/utils/form';
// import DateUtils from '@shared/utils/date';
// import Ellipsis from '@shared/components/Ellipsis';

import { DatePickerComponent, DatePickerModel } from '@syncfusion/ej2-react-calendars';
import { isDateEqualNoTime } from '@shared/utils/date';
// import './DatePicker.css';

// Custom Props for v4-material-ui-based DatePicker control
// type AllPickersProps =
//   Partial<Omit<KeyboardDateTimePickerProps, 'classes' | 'onChange'>> &
//   Partial<Omit<MuiDatePickerProps, 'classes' | 'onChange'>>;

// export interface DatePickerProps extends
//   WithStyles<typeof styles>,
//   AllPickersProps {
//   value?: string | null;
//   field?: Field;
//   format?: string;
//   withTimePicker?: boolean;
//   testAttributeArgs: {
//     module: string;
//     elementDescription: string;
//   };
//   startOfUnit?: moment.unitOfTime.StartOf;
//   endOfUnit?: moment.unitOfTime.StartOf;
//   onChange?: (value: string) => any;
// }

// Custom Props for syncfusion-based DatePickerComponent control
export interface DatePickerProps extends DatePickerModel {
  className?: string;
  classes?: Record<string, any>;
  field?: Field;
  startOfUnit?: moment.unitOfTime.StartOf;
  endOfUnit?: moment.unitOfTime.StartOf;
  disablePast?: boolean;
  minDate?: Date | string;
  maxDate?: Date | string;
  testAttributeArgs?: {
    module: string;
    elementDescription: string;
  };
  onChange?: (value: string) => any;
}

@observer
class DatePicker extends React.Component<DatePickerProps> {
  // static defaultProps = { 
  //   format: 'MMM DD, YYYY',
  // };

  // private getNormalizedDate = (date: MaterialUiPickersDate) => {
  //   if (!date) {
  //     return '';
  //   }

  //   const { startOfUnit, endOfUnit } = this.props;
    
  //   if (startOfUnit) {
  //     return date.startOf(startOfUnit).toISOString();
  //   }

  //   if (endOfUnit) {
  //     return date.endOf(endOfUnit).toISOString();
  //   }

  //   return date.toISOString();
  // }

  // private handleDateChange = (date: MaterialUiPickersDate) => {
  //   const { field, onChange } = this.props;
  //   const normalizedDate = this.getNormalizedDate(date);

  //   if (field) {
  //     field.set('value', normalizedDate);
  //     field.validate();
  //   }

  //   if (onChange) {
  //     onChange(normalizedDate);
  //   }
  // }

  // render() {
  //   const { 
  //     field, 
  //     value, 
  //     helperText, 
  //     label, 
  //     withTimePicker, 
  //     error, 
  //     testAttributeArgs, 
  //     classes, 
  //     startOfUnit, 
  //     endOfUnit,
  //     onChange, 
  //     ...otherProps 
  //   } = this.props;

  //   const pickerValue = field ? field.value : value;

  //   const commonProps = {
  //     inputProps: getTestAttr(testAttributeArgs.module, `${testAttributeArgs.elementDescription}`, 'date-picker'),
  //     value: pickerValue || null,
  //     name: field?.name,
  //     error: Boolean(error || field?.error),
  //     InputProps: {
  //       endAdornment: <DateRangeIcon className={classes.icon} />
  //     },
  //     helperText: null,
  //     ...getScrollAttr(otherProps.name || field?.name),
  //     onChange: this.handleDateChange,
  //   };
    
  //   const errorText = helperText || field?.error;

  //   return (
  //     <div className={cx(classes.root, { [classes.rootDisabled]: otherProps.disabled })}>
  //       <MuiPickersUtilsProvider utils={DateUtils}>
  //         {withTimePicker
  //           ? (
  //             <KeyboardDateTimePicker
  //               autoOk
  //               clearable
  //               variant="inline"
  //               {...commonProps}
  //               {...otherProps}
  //             />
  //           )
  //           : (
  //             <MuiDatePicker
  //               autoOk
  //               disablePast
  //               disableToolbar
  //               variant="inline"
  //               {...commonProps}
  //               {...otherProps}
  //             />
  //           )
  //         }
  //       </MuiPickersUtilsProvider>
  //       {commonProps.error && <Ellipsis classes={{ root: classes.errorText }} text={errorText} />}
  //     </div>
  //   );
  // }

  private getNormalizedDate = (date: Date) => {
    if (!date) {
      return '';
    }
    let tmpDate = moment(date);
    const { startOfUnit, endOfUnit } = this.props;
    
    if (startOfUnit) {
      return tmpDate.startOf(startOfUnit).toISOString();
    }

    if (endOfUnit) {
      return tmpDate.endOf(endOfUnit).toISOString();
    }

    return tmpDate.toISOString();
  }

  private handleDatePickerChange(params) {
    // console.log('*** (DatePicker) params', params);
    const { field, onChange } = this.props;
    const normalizedDate = this.getNormalizedDate(params.value);

    if (field) {
      const curDate = field.value;
      if (!isDateEqualNoTime(normalizedDate, curDate)) {
        field.set('value', normalizedDate);
        field.validate();
      }
    }

    if (onChange) {
      // console.log('*** (DatePicker) call onChange:', normalizedDate);
      onChange(normalizedDate);
    }
  }

  render() {
    const {
      field,
      value,
      minDate,
      maxDate,
      disablePast = false,
      testAttributeArgs,
      endOfUnit,
      onChange,
      ...otherProps 
    } = this.props;
    const classes = withStyles.getClasses(this.props);

    const pickerValue = field ? field.value : value;
    const min = (minDate !== undefined) ? (new Date(minDate)) : (disablePast ? (new Date()) : (new Date(1900, 0, 1)));
    const max = (maxDate !== undefined) ? (new Date(maxDate)) : new Date(2099, 11, 31);

    return (
      <div className={classes.root}>
          <DatePickerComponent
            value={pickerValue}
            change={this.handleDatePickerChange.bind(this)}
            min={min}
            max={max}
            style={{ fontSize: 17 }}
            {...otherProps}
            />
      </div>
    );
  }
}

const DatePickerStyled = withStyles(
  DatePicker, 
  (theme, props) => ({
    "root": {
      position: 'relative',
    },
    "rootDisabled": {
      ...theme.shortcuts.disabled
    },
    "icon": {
      marginLeft: theme.spacing(2),
      color: theme.palette.colors.greyLight3,
      cursor: 'pointer',
    },
    "errorText": {
      ...theme.shortcuts.errorText,
      bottom: -16
    }
  })
);

export default DatePickerStyled;